export const contractAddress = "0x0Aef24Ec313D717969247B9213164DEdFACc8985";

